import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { environment } from './services/environment';

void i18next
    .use(LanguageDetector)
    .use(Backend)
    .use(initReactI18next)
    .init({
        fallbackLng: 'en',
        debug: true,
        backend: {
            loadPath: `${environment.publicUrlPart}/locales/{{lng}}/{{ns}}.json`,
        },
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
    });

export { i18next };
